// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"03f33b06","453":"a22a4657","694":"a6d40dd9"}[chunkId] + ".chunk.js";
};